// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!./shared.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#language-picker {
  display: flex;
  position: relative;
  margin: 0.75rem;
  color: var(--darkgrey);
  width: 10rem;
  height: 2rem;
  background-color: var(--shell-bg-color);
  border-radius: 0.5rem;
  border: 1px solid var(--border-dark-color);
  box-sizing: border-box;
  cursor: pointer;
}

#language-picker.open {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

#language-picker.open #picker-popup {
      display: block;
    }

#language-picker:hover {
    background-color: var(--border-dark-bg-color);
    color: var(--menu-color-active);
  }

@media (max-width: 48rem) {

#language-picker {
    width: 4.7rem;
}
  }

#picker-content {
  flex-grow: 1;
  color: var(--darkgrey);
}

@media (max-width: 48rem) {
    #picker-content img {
      margin-right: 0;
    }

    #picker-content span {
      display: none;
    }
  }

#picker-indicator {
  display: flex;
  font-size: 1.5rem;
  width: 1rem;
  margin: 0.25rem 0.5rem;
  color: var(--darkgrey);
}

#picker-indicator svg {
    display: block;
  }

#picker-popup {
  display: none;
  position: absolute;
  top: 2rem;
  right: 0;
  border: 1px solid var(--border-dark-color);
  background-color: var(--menu-bg-color);
  margin-top: -2px;
  margin-right: -1px;
  padding: 0;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  min-width: 100%;
  list-style: none;
  z-index: 5;
  color: var(--menu-color);
}

#picker-popup li[aria-selected=true] {
      background-color: var(--menu-bg-color);
    }

#picker-popup li:hover {
      border-radius: 0.25rem;
      background-color: var(--theme-color);
      color: var(--menu-color-active);
    }

#picker-popup img, #picker-content img {
  height: 1.325rem;
  border-radius: 0.25rem;
  margin-right: 0.25rem;
}

#picker-popup li, #picker-content {
  padding: 0.25rem;
  line-height: 1.375rem;
  display: flex;
  align-content: center;
}
`, "",{"version":3,"sources":["webpack://./core/components/LanguagePicker.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,uCAAuC;EACvC,qBAAqB;EACrB,0CAA0C;EAC1C,sBAAsB;EACtB,eAAe;AAmBjB;;AAjBE;IACE,4BAA4B;IAC5B,6BAA6B;EAK/B;;AAHE;MACE,cAAc;IAChB;;AAGF;IACE,6CAA6C;IAC7C,+BAA+B;EACjC;;AAEA;;AA3BF;IA4BI,aAAa;AAEjB;EADE;;AAGF;EACE,YAAY;EACZ,sBAAsB;AAWxB;;AATE;IACE;MACE,eAAe;IACjB;;IAEA;MACE,aAAa;IACf;EACF;;AAGF;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,sBAAsB;AAKxB;;AAHE;IACE,cAAc;EAChB;;AAGF;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,0CAA0C;EAC1C,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,wBAAwB;AAa1B;;AAVI;MACE,sCAAsC;IACxC;;AAEA;MACE,sBAAsB;MACtB,oCAAoC;MACpC,+BAA+B;IACjC;;AAIJ;EACE,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,qBAAqB;AACvB","sourcesContent":["@import \"shared.css\";\r\n\r\n#language-picker {\r\n  display: flex;\r\n  position: relative;\r\n  margin: 0.75rem;\r\n  color: var(--darkgrey);\r\n  width: 10rem;\r\n  height: 2rem;\r\n  background-color: var(--shell-bg-color);\r\n  border-radius: 0.5rem;\r\n  border: 1px solid var(--border-dark-color);\r\n  box-sizing: border-box;\r\n  cursor: pointer;\r\n\r\n  &.open {\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n\r\n    & #picker-popup {\r\n      display: block;\r\n    }\r\n  }\r\n\r\n  &:hover {\r\n    background-color: var(--border-dark-bg-color);\r\n    color: var(--menu-color-active);\r\n  }\r\n\r\n  @media (max-width: 48rem) {\r\n    width: 4.7rem;\r\n  }\r\n}\r\n\r\n#picker-content {\r\n  flex-grow: 1;\r\n  color: var(--darkgrey);\r\n\r\n  @media (max-width: 48rem) {\r\n    & img {\r\n      margin-right: 0;\r\n    }\r\n\r\n    & span {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n#picker-indicator {\r\n  display: flex;\r\n  font-size: 1.5rem;\r\n  width: 1rem;\r\n  margin: 0.25rem 0.5rem;\r\n  color: var(--darkgrey);\r\n\r\n  & svg {\r\n    display: block;\r\n  }\r\n}\r\n\r\n#picker-popup {\r\n  display: none;\r\n  position: absolute;\r\n  top: 2rem;\r\n  right: 0;\r\n  border: 1px solid var(--border-dark-color);\r\n  background-color: var(--menu-bg-color);\r\n  margin-top: -2px;\r\n  margin-right: -1px;\r\n  padding: 0;\r\n  border-bottom-left-radius: 0.25rem;\r\n  border-bottom-right-radius: 0.25rem;\r\n  min-width: 100%;\r\n  list-style: none;\r\n  z-index: 5;\r\n  color: var(--menu-color);\r\n\r\n  & li {\r\n    &[aria-selected=true] {\r\n      background-color: var(--menu-bg-color);\r\n    }\r\n\r\n    &:hover {\r\n      border-radius: 0.25rem;\r\n      background-color: var(--theme-color);\r\n      color: var(--menu-color-active);\r\n    }\r\n  }\r\n}\r\n\r\n#picker-popup img, #picker-content img {\r\n  height: 1.325rem;\r\n  border-radius: 0.25rem;\r\n  margin-right: 0.25rem;\r\n}\r\n\r\n#picker-popup li, #picker-content {\r\n  padding: 0.25rem;\r\n  line-height: 1.375rem;\r\n  display: flex;\r\n  align-content: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
